import { useLocation, useNavigate } from 'react-router';
import { publicRoutes, RoutePaths } from '~/routes/constants';
import { AuthAccessor } from '~/utils/storage';
import { useLayoutEffect, useState } from 'react';

//TODO: Refactor and check to not see blink error screen on training page

export const usePermitted = (): true | null => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState<true | null>(null);

  const isPublicRoute = publicRoutes.includes(location.pathname);
  const accessToken = AuthAccessor.getAccessToken();
  const refreshToken = AuthAccessor.getRefreshToken();

  useLayoutEffect(() => {
    if (accessToken || refreshToken || isPublicRoute) {
      setIsAllowed(true);
      return;
    } else {
      navigate(RoutePaths.LOGIN, { replace: true });
      setIsAllowed(null);
    }
  }, [location.pathname, accessToken, navigate]);

  return isAllowed;
};
